import React, { useEffect, useMemo } from 'react';

import {
  Text, Stack, Flex,
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';

import { getCompany } from 'api/company';
import { Button, Icon } from 'components';
import { breadcrumbs } from 'constants/routes';
import BreadcrumbMenu from 'containers/Breadcrumb';
import { CompanyInfo } from 'containers/Company';
import Page from 'containers/Page/index';
import { ContentRoutes } from 'enums/routes';
import { AccessTypes, MethodTypes } from 'enums/types';
import { useFormModal } from 'hooks/useFormModal';
import { policy } from 'polices';
import useCompany from 'stores/useCompany';

export default function Company() {
  const { company, refetch } = useCompany();
  const { id } = useParams<GeneralRoute>();
  const {
    onOpen, setUpdateId, setDefaultValues, Form,
  } = useFormModal(id ? ContentRoutes.Companies : ContentRoutes.Company);

  const policies = policy('company');
  const { push } = useHistory();
  const isEditable = useMemo(() => policies(MethodTypes.Update) === AccessTypes.Allow, [policies]);

  const { data, isFetching, refetch: refetchCompanies } = useQuery(['company', id, company], async () => {
    if (id) {
      return getCompany({ id });
    }
    return { data: company };
  });

  useEffect(() => {
    if (policies(MethodTypes.View) !== AccessTypes.Allow) {
      push('/403');
    }
  }, []);

  return (
    <Page isLoading={isFetching}>
      <Form onSuccess={id ? refetchCompanies : refetch} />
      <Stack
        w="1024px"
        alignSelf="center">
        <BreadcrumbMenu paths={[
          ...breadcrumbs[id ? 'companies' : 'company'],
          {
            label: data?.data?.name,
            path: window.location.pathname,
          },
        ]}
        />
        <Flex
          width="100%"
          justifyContent="space-between">
          <Text variant="3xLargeBold">{data?.data?.name}</Text>
          <Button
            hidden={!isEditable}
            onClick={() => {
              if (id) {
                setUpdateId(data?.data?.id);
              }
              setDefaultValues(data.data);
              onOpen();
            }}
            shadow={1}
            bg="white.default"
            _hover={{
              bg: 'primary.700',
              color: 'white.default',
            }}
            borderRadius={50}
            h={8}
            _active={{
              color: 'white.default',
            }}
            color="gray.500">
            <Text variant="xSmallSemiBold">Editar</Text>
            <Icon
              ml={2}
              name="edit"
            />
          </Button>
        </Flex>
        <Stack spacing={5}>
          <CompanyInfo data={data?.data} />
        </Stack>
      </Stack>
    </Page>
  );
}
